import { TheNightlySection } from '@news-mono/common'
import { StaticRoutes } from '@news-mono/web-common'
import { createElectionRoutes } from './pages/createRoutes'

export const electionRoutes: StaticRoutes<TheNightlySection> = {
    ...createElectionRoutes({ type: 'federal' }, 2025),
    ...createElectionRoutes({ type: 'state', state: 'wa' }, 2025),
}
